import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class ScaleImageAction extends AbstractProvidedClass {
    isImageAction = true;

    constructor(provider, scale) {
        super(provider);

        this.scale = scale;
    }

    finish() {
        this.image.scale(this.scale);
        this.actions.finish();
    }

    undo() {
        this.image.scale(1 / this.scale);
    }

    redo() {
        this.image.scale(this.scale);
    }
}
